import React from "react";
import clsx from "clsx";
import { Col } from "react-bootstrap";

import { FormRow } from "components/layout";

import styles from "./scheduleA.module.scss";

export const FeesHeader = () => {
	return (
		<FormRow className={styles.feesHeader}>
			<Col
				className={clsx(styles.pricingText, "text-grey", "text-nowrap")}
			>
				Pricing Element
			</Col>
			<Col>Pricing Method</Col>
			<Col>Rate, %</Col>
			<Col>Per Item Fee, $</Col>
			<Col className="text-nowrap">Revenue Share, %</Col>
			<Col
				className={clsx(styles.pricingText, "text-grey", "text-nowrap")}
			>
				Calculation
			</Col>
		</FormRow>
	);
};
